import { useGetData } from '../../api/api-tools';

export const useTargetsByDeviceId = (deviceId) => {
  const queryKey = `targets_by_deviceId:${deviceId}`;
  const query = `targets?device.id=${deviceId}`;
  const { data } = useGetData(queryKey, query, {}, !!deviceId);

  return { data, queryKey };
};
